import React, { ReactNode } from "react";
import { Modal } from "react-bootstrap";

type MsgBoxPropsType = {
    title: ReactNode;
    body: ReactNode | ((x: any) => any);
    buttons: any;
    size?: "sm" | "lg" | "xl";
    backdropClassName?: string;
    className?: string;
    dialogClassName?: string;
    contentClassName?: string;
    fullscreen?: true | string | "sm-down" | "md-down" | "lg-down" | "xl-down" | "xxl-down";
    onClose: () => void;
};

type MsgBoxStateType = {
    open: boolean;
};

export class MsgBox extends React.Component<MsgBoxPropsType, MsgBoxStateType> {
    constructor(props) {
        super(props);
        this.state = { open: true };
    }

    renderBody = () => {
        if (!this.props.body) return null;
        if (typeof this.props.body === "function") {
            return this.props.body(this.onHideHandler);
        }
        return this.props.body;
    };

    renderButtons = () => {
        if (!this.props.buttons) return null;
        if (typeof this.props.buttons === "function") {
            return this.props.buttons(this.onHideHandler);
        }
        return <>{this.props.buttons}</>;
    };

    onHideHandler = () => {
        this.setState({ open: false });
        this.props.onClose();
    };

    render() {
        return (
            <>
                <Modal
                    show={this.state.open}
                    onHide={this.onHideHandler}
                    size={this.props.size}
                    backdropClassName={this.props.backdropClassName}
                    className={this.props.className}
                    dialogClassName={this.props.dialogClassName}
                    contentClassName={this.props.contentClassName}
                    fullscreen={this.props.fullscreen}
                >
                    {this.props.title && (
                        <Modal.Header className="p-4 pb-0 mb-n2">
                            <Modal.Title className="h5">{this.props.title}</Modal.Title>
                        </Modal.Header>
                    )}
                    <Modal.Body className="p-4">
                        {this.props.body && <div className="text-secondary-text">{this.renderBody()}</div>}
                        {this.props.buttons && <div className="pt-4 mb-n2 text-end">{this.renderButtons()}</div>}
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}
